<template id="Unassigned__patient__visits">
    <section class="central-background">
        <div>
            <div class="py-0 d-flex justify-content-center third-level-nav">
                <div class="horizontal-nav-bar rounded-top">
                    <div
                        class="d-flex bg-white rounded-top"
                        id="solution-tab"
                        role="tablist"
                        aria-orientation="horizontal"
                    >
                        <a
                            v-for="tab in tabs"
                            :class="`nav-link d-flex justify-content-between align-items-center ${
                                activeTab === tab.id ? 'active' : ''
                            } ${!allowedTabs.includes(tab.id) ? 'disabled-tab' : ''}`"
                            :id="`v-pills-${tab.id}`"
                            data-bs-toggle="pill"
                            :href="allowedTabs.includes(tab.id) ? `#v-pills-${tab.id}` : 'javascript:void(0)'"
                            role="tab"
                            :key="tab.id"
                            aria-selected="true"
                            :disabled="!allowedTabs.includes(tab.id)"
                            @click="handleTabChange(tab)"
                        >
                            {{ tab.name }} <span class="visit-count px-1 ms-2">{{ tab.count }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="tab-content" id="v-pills-tabContent">
                <div>
                    <section class="px-3 mb-2">
                        <div v-if="activeTab === ApplicationEnum.AgencyCore">
                            <UnassignedPatientVisitsHomeHealth />
                        </div>
                        <div v-if="activeTab === ApplicationEnum.HomeCare">
                            <UnassignedPatientVisitsHCHOSPAL
                                :application="ApplicationEnum.HomeCare"
                                :get-unassigned-patients-visits="getUnassignedPatientsVisits"
                                :export-unassigned-patients-visits="exportUnassignedPatientsVisits"
                            />
                        </div>
                        <div v-if="activeTab === ApplicationEnum.AxxessHospiceFE">
                            <UnassignedPatientVisitsHCHOSPAL
                                :application="ApplicationEnum.AxxessHospiceFE"
                                :get-unassigned-patients-visits="getUnassignedPatientsVisits"
                                :export-unassigned-patients-visits="exportUnassignedPatientsVisits"
                            />
                        </div>
                        <div v-if="activeTab === ApplicationEnum.AxxessPalliative">
                            <UnassignedPatientVisitsHCHOSPAL
                                :application="ApplicationEnum.AxxessPalliative"
                                :get-unassigned-patients-visits="getUnassignedPatientsVisits"
                                :export-unassigned-patients-visits="exportUnassignedPatientsVisits"
                            />
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" src="./UnassignedPatientVisits.ts"></script>
<style src="./UnassignedPatientVisits.scss"></style>
